/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

export class WorkforceCalendarRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.appService.app.canUseFeature('wfm-calendar')) {
      this.router.transitionTo('apps.app.workforce');
      return;
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(WorkforceCalendarRoute);
